export default __webpack_public_path__ + "static/media/BuildingEssestials-Gif.88501b70.gif";